import { render, staticRenderFns } from "./form8.vue?vue&type=template&id=38c48597&scoped=true&"
import script from "./form8.vue?vue&type=script&lang=js&"
export * from "./form8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c48597",
  null
  
)

export default component.exports